module.exports = __webpack_public_path__ + "assets/img/36_1450_big.e2f70e71.jpg";